import styles from './PlaceBadge.module.css';

const placeClass: Record<number, string> = { 1: styles.p1, 2: styles.p2, 3: styles.p3 };

export function PlaceBadge({ place }: { place: number }) {
  const cls = placeClass[place] ?? styles.pOther;
  return <span className={`${styles.badge} ${cls}`}>{place}</span>;
}
